import { useAuth } from "../lib/auth";
import { Link } from "react-router-dom";
import { Sparkles, MessageCircle, ArrowRight } from "lucide-react";

const OWNER_WA = "6282397614466";
const WA_URL = `https://wa.me/${OWNER_WA}?text=${encodeURIComponent("Halo, saya sudah coba demo PondokRaja dan tertarik menggunakan untuk homestay saya.")}`;

export default function DemoBanner() {
  const { user, logout } = useAuth();
  const isDemo = user?.email === "demo@pondokraja.com";

  if (!isDemo) return null;

  return (
    <div
      data-testid="demo-banner"
      className="-mx-4 sm:-mx-6 lg:-mx-12 -mt-6 lg:-mt-12 mb-0 bg-[#D16B4D] text-white"
    >
      <div className="px-4 sm:px-6 lg:px-12 py-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <div className="h-7 w-7 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
            <Sparkles className="h-3.5 w-3.5" />
          </div>
          <div className="text-sm">
            <strong className="font-bold">Mode Demo</strong>
            <span className="opacity-90 ml-1.5 hidden sm:inline">— Anda sedang menjelajahi data contoh. Perubahan akan tersimpan di database demo, tidak memengaruhi homestay sungguhan.</span>
            <span className="opacity-90 ml-1.5 sm:hidden">— Data contoh</span>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
          <a href={WA_URL} target="_blank" rel="noreferrer" className="flex-1 sm:flex-initial">
            <button
              data-testid="btn-demo-contact"
              className="w-full sm:w-auto bg-white text-[#D16B4D] hover:bg-white/90 rounded-lg px-3 py-1.5 text-xs font-bold flex items-center justify-center gap-1.5 transition-colors"
            >
              <MessageCircle className="h-3.5 w-3.5" />
              Tanya via WA
            </button>
          </a>
          <Link to="/" onClick={logout} className="flex-1 sm:flex-initial" data-testid="btn-exit-demo">
            <button className="w-full sm:w-auto border border-white/40 hover:bg-white/10 rounded-lg px-3 py-1.5 text-xs font-bold flex items-center justify-center gap-1.5 transition-colors">
              Keluar Demo
              <ArrowRight className="h-3.5 w-3.5" />
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
